import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class MapsHeader extends Component {
    render() {
        return (
            <div className="MapsHeader">
                <Link className="MapsHeaderBrandLink" to="/">
                    <img className="MapsHeaderBrandLogo" src="/Images/logo.svg" alt="Ling" width="64" height="64" />
                    <h1 className="MapsHeaderBrandTitle title has-text-white is-size-5">Ling Maps</h1>
                </Link>
            </div>
        );
    }
}

export default MapsHeader;


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsHeader.js